//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "QfActionTrigger",
    props: {
        label: { type: String },
        icon: { type: String, default: "mdi-menu-right" }
    },
    methods: {
        onClick() {
            this.$emit("click");
        }
    }
};
